import type {
  CreateTransferRequest,
  DecideTransferRequest,
  TransferResponse,
} from '@tabita/contracts';
import { apiRequest } from './api-client';

export const transfersApi = {
  listForPerson(personId: string, signal?: AbortSignal) {
    return apiRequest<readonly TransferResponse[]>(`/people/${personId}/transfers`, { signal });
  },

  listPending(signal?: AbortSignal) {
    return apiRequest<readonly TransferResponse[]>('/people/transfers/pending', { signal });
  },

  create(personId: string, body: CreateTransferRequest) {
    return apiRequest<TransferResponse>(`/people/${personId}/transfers`, {
      method: 'POST',
      body,
    });
  },

  approve(transferId: string, body: DecideTransferRequest) {
    return apiRequest<TransferResponse>(`/people/transfers/${transferId}/approve`, {
      method: 'POST',
      body,
    });
  },

  reject(transferId: string, body: DecideTransferRequest) {
    return apiRequest<TransferResponse>(`/people/transfers/${transferId}/reject`, {
      method: 'POST',
      body,
    });
  },

  cancel(transferId: string) {
    return apiRequest<TransferResponse>(`/people/transfers/${transferId}/cancel`, {
      method: 'POST',
    });
  },
};
